import React from "react";

export default function TextIframe(props) {
  //console.log ("src", props.src)
  return (
    props.isMobile ? (
    <div 
    style={{
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "80vw",
      height: "80vh",
    }}>
          <iframe
            src={props.src}
            width="9vw" 
            height="1000vh" 
            allowtransparency="true"
          ></iframe>
    </div>
      )  : 
      <div 
    style={{
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "black",
      overflow: "hidden",
      //width: "80vw",
      //height: "100vh",
      //left: "10vw",
     }}>
      (
          <iframe
            src={props.src}  
            width="1300vw" 
            height="800vh" 
            allowtransparency="true"
            frameBorder="0"
            //sandbox='allow-scripts allow-modal'
            //allowFullScreen={true}
          ></iframe>
      )
    </div>
  );
}
